import {FORMAT_TEXT_MAP, MockTracer} from 'opentracing'


const tracer = new MockTracer;
const span = tracer.startSpan('app');

export {tracer, span}